import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { HoveringTimelines } from "../../../../Constant";
import { UL } from "../../../../AbstractElements";
import { MeetupHoveringTimeline } from "./MeetupHoveringTimeline";
import { InterviewHoveringTimeline } from "./InterviewHoveringTimeline";
import { AnnualFunctionHoveringTimeline } from "./AnnualFunctionHoveringTimeline";
import { HOVERING_TIMELINE } from "../../../../Data/Bonus Ui/Timeline";

const HoveringTimeline = () => {
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={HoveringTimelines} span={HOVERING_TIMELINE} />
        <CardBody className="dark-timeline">
          <UL className="square-timeline simple-list">
            <AnnualFunctionHoveringTimeline />
            <InterviewHoveringTimeline />
            <MeetupHoveringTimeline />
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default HoveringTimeline;
